import { Injectable, inject, Renderer2, RendererFactory2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PageMetaService {

  private readonly title = inject(Title);
  private readonly document = inject(DOCUMENT);

  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
   * Установка title страницы
   */
  setTitle(sessionId: string | number, pageTitle: string): void {
    this.title.setTitle( sessionId ? `${sessionId}: ${pageTitle}` : pageTitle);
  }

  /**
   * Установка favicon
   */
  setFavicon(iconPath: string, type: string = 'image/svg+xml'): void {
    let link = this.document.querySelector<HTMLLinkElement>(
      "link[rel='icon']"
    );

    if (!link) {
      link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'icon');
      this.renderer.appendChild(this.document.head, link);
    }

    this.renderer.setAttribute(link, 'type', type);
    this.renderer.setAttribute(link, 'href', iconPath);
  }

  /**
   * Универсальный метод (title + favicon)
   */
  setPageMeta(
    sessionId: string | number,
    pageTitle: string,
    faviconPath?: string
  ): void {
    this.setTitle(sessionId, pageTitle);

    if (faviconPath) {
      this.setFavicon(faviconPath);
    }
  }
}
